const getNomaVenueID = () => null;

export default getNomaVenueID;
